// extracted by mini-css-extract-plugin
module.exports = {"sortingContainer":"SortingScreen_sortingContainer__rZTWZ","description":"SortingScreen_description__MB2rt"};